import { DateRange } from "@intentsify/types";
import { atom } from "jotai";

export const mostResearchedTopicsDateRangeAtom = atom<DateRange>(
  DateRange.LastFourWeeks
);

export const mostResearchedKeywordsDateRangeAtom = atom<DateRange>(
  DateRange.LastFourWeeks
);
